
import { filterObj } from '@/utils/util'
import { getAction, postAction,downFile  } from '@/api/manage'

export const ReportListMixin = {
    data(){
        return {
            /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
            queryParam: {},
            /* 数据源 */
            dataSource:[],
            // 表格缓存的数据 - 用来点击取消时回显数据
            cacheData: [],
            /* 分页参数 */
            ipagination:{
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            /* 排序参数 */
            isorter:{
                column: 'createTime',
                order: 'desc',
            },
            /* 筛选参数 */
            filters: {},
            /* table加载状态 */
            loading:false,
            /* table选中keys*/
            selectedRowKeys: [],
            /* table选中records*/
            selectionRows: [],
            /* 查询折叠 */
            toggleSearchStatus:true,
        }
    },
    computed: {
      language() {
        return this.$store.getters.language;
      },
    },
    methods:{
        searchQueryCus(arg){//查询
            if(!this.url.list){
                this.$message.error(this.language['common.plsSetUrlList'])//("请设置url.list属性!")
                return
            }

            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
              this.ipagination.current = 1;
            }

            var params = this.getQueryParams();//查询条件
            this.loading = true;
            postAction(this.url.list, params).then((res) => {
                if (res.success) {
                    //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
                    const result = res.result.records || res.result
                    this.dataSource = result.map((v, i)=>{
                        v.key = i + 1;
                        return v;
                    });
                    // this.cacheData = JSON.parse(JSON.stringify(res.result.records));

                    if(res.result.total){
                        this.ipagination.total = res.result.total;
                    }else{
                        this.ipagination.total = 0;
                    }
                    // 自定义函数:
                    if (this.loadDataCus && typeof (this.loadDataCus) === 'function') {
                        this.loadDataCus()
                    }

                    //切换页签
                    // this.callback(this.tempKey);
                }else{
                  this.$message.warning(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },

        getQueryParams() {
            //获取查询条件
            let sqp = {}
            if(this.superQueryParams){
                sqp['superQueryParams']=encodeURI(this.superQueryParams)
                sqp['superQueryMatchType'] = this.superQueryMatchType
            }
            var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
            param.field = this.getQueryField();
            param.pageNo = this.ipagination.current;
            param.pageSize = this.ipagination.pageSize;
            return filterObj(param);
        },

        getQueryField() {//获取查询字段
            var str = "id,";
            this.columns.forEach(function (value) {
                str += "," + value.dataIndex;
            });
            return str;
        },

        searchResetCus() {//重置
            this.queryParam = {}
            this.searchQueryCus(1);
        },

        handleToggleSearch(){//展开/收起 查询条件
            this.toggleSearchStatus = !this.toggleSearchStatus;
        },

        onClearSelected() {//清空已选中
            this.selectedRowKeys = [];
            this.selectionRows = [];
        },

        handleTableChange(pagination, filters, sorter) {//监听 排序/分页
            //分页、排序、筛选变化时触发
            console.log(pagination)
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.searchQueryCus();
        },

        onSelectChange(selectedRowKeys, selectionRows) {//监听 多选框是否选中
            this.selectedRowKeys = selectedRowKeys;
            this.selectionRows = selectionRows;
            this.id = this.selectionRows[0].id;
            this.disabledState = this.selectionRows.length !== 1
        },

        handleExportXls(fileName){//导出
          if(!fileName || typeof fileName != "string"){
            fileName = "导出文件"
          }
          let param = this.getQueryParams();
          if(this.selectedRowKeys && this.selectedRowKeys.length>0){
            param['selections'] = this.selectedRowKeys.join(",")
          }
          console.log("导出参数",param)
          downFile(this.url.exportXlsUrl,param).then((data)=>{
            if (!data) {
              this.$message.warning("文件下载失败")
              return
            }
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
            }else{
              let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', fileName+'.xls')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link); //下载完成移除元素
              window.URL.revokeObjectURL(url); //释放掉blob对象
            }
          })
        },

        modalFormOk() {
            // 新增/修改 成功时，重载列表
            this.loadData();
            //清空列表选中
            this.onClearSelected()
        },

          handleAdd: function () {
            this.$refs.modalForm.add();
            this.$refs.modalForm.title = "新增";
            this.$refs.modalForm.disableSubmit = false;
          },

          handleEditEmp: function (record) {
            this.$refs.modalFormEmp.edit(record);
            this.$refs.modalFormEmp.title = "编辑";
            this.$refs.modalFormEmp.disableSubmit = false;
          },

          handleEdit: function (record) {
            this.$refs.modalForm.edit(record);
            this.$refs.modalForm.title = "编辑";
            this.$refs.modalForm.disableSubmit = false;
          },

          handleDetailEmp:function(record){
            this.$refs.modalFormEmp.edit(record);
            this.$refs.modalFormEmp.title="详情";
            this.$refs.modalFormEmp.disableSubmit = true;
          },

          batchDel: function () {
            if(!this.url.deleteBatch){
              this.$message.error("请设置url.deleteBatch属性!")
              return
            }
            if (this.selectedRowKeys.length <= 0) {
              this.$message.warning('请选择一条记录！');
              return;
            } else {
              var ids = "";
              for (var a = 0; a < this.selectedRowKeys.length; a++) {
                ids += this.selectedRowKeys[a] + ",";
              }
              var that = this;
              this.$confirm({
                title: "确认删除",
                content: "是否删除选中数据?",
                onOk: function () {
                  that.loading = true;
                  deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                    if (res.success) {
                      //重新计算分页问题
                      that.reCalculatePage(that.selectedRowKeys.length)
                      that.$message.success(res.message);
                      that.loadData();
                      that.onClearSelected();
                    } else {
                      that.$message.warning(res.message);
                    }
                  }).finally(() => {
                    that.loading = false;
                  });
                }
              });
            }
          },

          reCalculatePage(count){
            //总数量-count
            let total=this.ipagination.total-count;
            //获取删除后的分页数
            let currentIndex=Math.ceil(total/this.ipagination.pageSize);
            //删除后的分页数<所在当前页
            if(currentIndex<this.ipagination.current){
              this.ipagination.current=currentIndex;
            }
            console.log('currentIndex',currentIndex)
          },

    }
}